import React from 'react';
import { useEditor, EditorContent, EditorOptions } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Youtube from '@tiptap/extension-youtube';
import { DefaultEditorOptions, RichTextInput, RichTextInputToolbar, TiptapEditorProvider, useTiptapEditor } from 'ra-input-rich-text';
import {
    AlignmentButtons,
    ClearButtons,
    FormatButtons,
    LevelSelect,
    ListButtons,
    LinkButtons,
    ImageButtons,
    QuoteButtons,
    ColorButtons
} from 'ra-input-rich-text';
import { styled } from '@mui/material/styles';
import { Color } from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import { YoutubeButton } from './youtube-button';

export const BlogEditor = () => {
    const classes = {
        editorContent: `blog-editorContent`,
    };
    const size = 'medium';

    return (
        <div>
            {/* <RichTextInputToolbar>
                <LevelSelect size={size} editor={editor}  />
                <FormatButtons size={size} editor={editor} />
                <ColorButtons size={size} editor={editor} />
                <AlignmentButtons size={size} />
                <ListButtons size={size} />
                <LinkButtons size={size} />
                <ImageButtons size={size} />
                <QuoteButtons size={size} />
                <ClearButtons size={size} />
                <YoutubeButton editor={editor} />
            </RichTextInputToolbar> 
            Display the editor content 
            <EditorContent editor={editor} /> */}
            <RichTextInput
                source="content"
                className=""
                editorOptions={MyEditorOptions}
                toolbar={
                   <MyRichTextInputToolbar size={size} />
                }
                
            />


        </div>
    );
};

export const MyEditorOptions = {
    ...DefaultEditorOptions,
    extensions: [
        ...DefaultEditorOptions.extensions,
        Youtube,
    ],
};

const MyRichTextInputToolbar = ({ size, ...props }) => {
    const editor = useTiptapEditor();

    return (
        <RichTextInputToolbar {...props}>
            <LevelSelect size={size} />
            <FormatButtons size={size} />
            <ColorButtons size={size} />
            <AlignmentButtons size={size} />
            <ListButtons size={size} />
            <LinkButtons size={size} />
            <ImageButtons size={size} />
            <QuoteButtons size={size} />
            <ClearButtons size={size} />
            <YoutubeButton editor={editor} />
        </RichTextInputToolbar>
    );
}